import { render, staticRenderFns } from "./AlarmEmptyDefaultLayout.vue?vue&type=template&id=5f54336c&scoped=true&"
import script from "./AlarmEmptyDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./AlarmEmptyDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f54336c",
  null
  
)

export default component.exports